<canvas
  baseChart
  [data]="chartData"
  [options]="barChartOptions"
  [legend]="false"
  [type]="'bar'"
>
</canvas>
